import { Sector, SectorValues } from '@/domain/impact/impact.entity';
import {
  ImpactCo2Answer,
  NonRecyclableWasteType,
  Source,
  SourceValues,
  ValuesNonRecyclableWaste,
} from '@/domain/impact-co2/entities/question.entity';
import { NonRecyclableWasteTypeValues } from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { QuestionNonRecyclableWasteDto } from './dto.type';

export class QuestionNonRecyclableWasteMapper {
  static dtoToEntity(
    dto: QuestionNonRecyclableWasteDto,
  ): ImpactCo2Answer<ValuesNonRecyclableWaste> {
    return {
      id: dto.id,
      userId: dto.userId,
      sector: validateValueInType<Sector>(dto.sector, SectorValues),
      category: 'NON_RECYCLABLE_WASTE',
      isExternal: dto.isExternal,
      source: validateValueInType<Source>(dto.source || '', SourceValues),
      values: {
        nonRecyclableWasteType: validateValueInType<NonRecyclableWasteType>(
          dto.nonRecyclableWasteType,
          NonRecyclableWasteTypeValues,
        ),
        nonRecyclableWasteQuantity: parseFloat(
          dto.nonRecyclableWasteQuantity.toString(),
        ),
        label: dto.label || '',
        score: dto.score || 0,
        tags:
          dto?.tags?.values?.map((tag) => ({ id: tag.id, name: tag.name })) ||
          [],
      },
    };
  }

  static entityToDto(
    answer: ImpactCo2Answer<ValuesNonRecyclableWaste>,
    projectId: number,
  ): Omit<
    QuestionNonRecyclableWasteDto,
    'id' | 'userId' | 'score' | 'isExternal'
  > {
    return {
      projectId: projectId,
      sector: answer.sector,
      nonRecyclableWasteType: answer.values.nonRecyclableWasteType,
      nonRecyclableWasteQuantity: answer.values.nonRecyclableWasteQuantity,
      label: answer.values.label || '',
      source: answer.source !== '' ? answer.source : undefined,
      tags: { values: answer.values.tags },
    };
  }
}
